<script lang="ts">
  import { getNow, getTimeZone } from "../../data/clock";
  import { isScheduled, getPlaceScheduleGroups } from "../../domain/places";
  import { partition } from "lodash-es";
  import Opening from "./opening.svelte";
  import OpeningSoon from "./opening-soon.svelte";
  import ClosingSoon from "./closing-soon.svelte";
  import OpenNow from "./open-now.svelte";
  import ClosedNow from "./closed-now.svelte";
  import Unscheduled from "./unscheduled.svelte";
  import type { Place, PlaceHoursGroup } from "../../types";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let places: Place[] = [];
  export let placeHoursGroups: PlaceHoursGroup[] = [];
  export let showSubtitle = false;

  $: [scheduled, unscheduled] = partition(places, (place) =>
    isScheduled(place, placeHoursGroups, $time)
  );
  $: groups = getPlaceScheduleGroups(scheduled, placeHoursGroups, $time, $timeZone);
</script>

<ClosingSoon schedule={groups.closingSoon || []} {showSubtitle} {time} />
<OpenNow schedule={groups.open || []} {showSubtitle} {time} />
<OpeningSoon schedule={groups.openingSoon || []} {showSubtitle} {time} />
<Opening schedule={groups.opening || []} {showSubtitle} {time} />
<ClosedNow schedule={groups.closed || []} {showSubtitle} {time} />

<Unscheduled places={unscheduled} {showSubtitle} {time} />
